import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  TableCell,
  Paper,
  TableBody,
  Avatar,
} from "@mui/material";
import React from "react";
import { openLeadExpandModal } from "../../../../../components/LeadPopup/hooks/useLeadCard";
import { useDispatch } from "react-redux";

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  lineHeight: "18px",
  backgroundColor: "#073E53",
  color: "#FFFFFF",
  textTransform: "capitalize",
  fontWeight: "400",
  fontSize: 14,
  padding: theme.spacing(1),
  paddingTop: "15px",
  paddingBottom: "15px",
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  fontSize: "12px",
  color: "#667085",
  padding: theme.spacing(1),
  paddingTop: "15px",
  paddingBottom: "10px",
}));

function RevenuePendingTab(props: any) {
  const { tableData, id } = props;
  const dispatch = useDispatch();
  return (
    <div>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: "8px",
          border: "1px solid #EAECF0",
          height: "calc(100vh - 100px)",
          overflowY: "scroll",
          boxShadow: "none",
          flexGrow: 1,
          width: "100%",
          maxHeight: "calc(100vh - 220px)",
          minHeight: "calc(100vh - 220px)",
        }}
      >
        <Table sx={{ minWidth: 700 }}>
          <TableHead
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 999,
            }}
          >
            <TableRow>
              <StyledTableCellHead
                sx={{
                  minWidth: 250,
                }}
              >
                Name{" "}
                {`${tableData?.length > 0 ? `(${tableData?.length})` : ""}`}
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 150,
                }}
              >
                Phone Number
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 200,
                }}
              >
                Email
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 200,
                }}
              >
                Course
              </StyledTableCellHead>

              <StyledTableCellHead
                sx={{
                  minWidth: 200,
                }}
              >
                Batch
              </StyledTableCellHead>

              <StyledTableCellHead
                sx={{
                  minWidth: 150,
                }}
              >
                Balance
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 150,
                }}
              >
                Due date
              </StyledTableCellHead>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData?.map((report: any, index: any) => (
              <TableRow key={index}>
                <StyledTableCellBody>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      textTransform: "capitalize",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      openLeadExpandModal(
                        id,
                        report?.studentContact,
                        report?.studentEmail,
                        report?.enquiryId,
                        dispatch,
                        "payment"
                      );
                    }}
                  >
                    <div>
                      <Avatar
                        sx={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "50%",
                          fontSize: "11px",
                          background: "#EEEEF4",
                          border: "1px solid #F5F5F7",
                          fontFamily: "Poppins",
                          fontWeight: "500",
                          color: "#667085",
                          textTransform: "uppercase",
                        }}
                      >
                        {report?.studentFirstName?.charAt(0) +
                          report?.studentLastName?.charAt(0)}
                      </Avatar>
                    </div>
                    <div>
                      {`${
                        report?.studentFirstName + " " + report?.studentLastName
                      }`}
                    </div>
                  </div>
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {report?.studentContact
                    ? `+${report?.contactCountryCode || "91"} ${
                        report?.contactCountryCode
                          ? report?.studentContact?.replace(
                              report?.contactCountryCode,
                              ""
                            )
                          : report?.studentContact?.startsWith("91")
                          ? report?.studentContact?.replace("91", "")
                          : report?.studentContact
                      }`
                    : "-"}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {report?.studentEmail}
                </StyledTableCellBody>
                <StyledTableCellBody
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  {report?.courseName}
                </StyledTableCellBody>
                <StyledTableCellBody
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  {report?.batchName}
                </StyledTableCellBody>

                <StyledTableCellBody
                  sx={{
                    fontSize: "16px",
                    color: "#1877F2",
                    fontFamily: "Roboto",
                  }}
                >
                  {report?.branchCurrency + "" + report?.balance}
                </StyledTableCellBody>
                <StyledTableCellBody>-</StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default RevenuePendingTab;
